
import { Component, Vue, Prop} from 'vue-property-decorator';

import * as SurveyVue from "survey-vue";
import * as surveyEnv from "@/components/survey/survey-glossary";
import surveyJson from "./forms/about-existing-child-support.json";
import PageBase from "../../PageBase.vue";
import { togglePages } from '@/components/utils/TogglePages';
import { stepInfoType, stepResultInfoType } from "@/types/Application";
import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

@Component({
    components:{
        PageBase
    }
})

export default class AboutExistingChildSupport extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.State
    public steps!: stepInfoType[];

    

    

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    survey = new SurveyVue.Model(surveyJson);  
    
    currentStep =0;
    currentPage =0;
    existingType = "";

    beforeCreate() {
        const Survey = SurveyVue;
        surveyEnv.setCss(Survey);
    }    

    mounted(){
        this.initializeSurvey();
        this.addSurveyListener();
        this.reloadPageInformation();
    }

    public initializeSurvey(){        
        this.survey = new SurveyVue.Model(surveyJson);
        this.survey.commentPrefix = "Comment";
        this.survey.showQuestionNumbers = "off";
        this.survey.showNavigationButtons = false;
        surveyEnv.setGlossaryMarkdown(this.survey);
    }    
    
    public addSurveyListener(){
        this.survey.onValueChanged.add((sender, options) => {
            Vue.filter('surveyChanged')('familyLawMatter')

            this.setPages();            
        })
    }

    public setPages(){            
            
        const AboutCS = this.stPgNo.FLM.AboutChildSupportChanges

        if (this.existingType == 'ExistingOrder') {                
            if(this.survey.data?.orderDifferenceType == 'changeOrder'){
                togglePages([AboutCS], true, this.currentStep);
                
            } else if(['cancelOrder', 'suspendedOrder'].includes(this.survey.data?.orderDifferenceType)) {
                
                togglePages([AboutCS], false, this.currentStep);
            }
        } else if (this.existingType == 'ExistingAgreement') {
            
            if(this.survey.data?.agreementDifferenceType == 'replacedAgreement'){
                togglePages([AboutCS], true, this.currentStep);
                
            } else if(this.survey.data?.agreementDifferenceType == 'setAsideAgreement') {
                
                togglePages([AboutCS], false, this.currentStep);
            }
        }
    }
    
    public reloadPageInformation() {   
        
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;

        if (this.step.result?.childSupportOrderAgreementSurvey) {
            const existingTypeData = this.step.result.childSupportOrderAgreementSurvey.data;
            
            this.survey.setVariable("existingType", existingTypeData.existingType)
            this.existingType = existingTypeData.existingType;
        }

        if (this.step.result?.aboutExistingChildSupportSurvey) {
            this.survey.data = this.step.result.aboutExistingChildSupportSurvey.data;           
            
            Vue.filter('scrollToLocation')(this.$store.state.Application.scrollToLocationName);            
        }        
       
        Vue.filter('setSurveyProgress')(this.survey, this.currentStep, this.currentPage, 50, false);

        this.setPages();
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {
        if(!this.survey.isCurrentPageHasErrors) {
            Vue.prototype.$UpdateGotoNextStepPage()
        }
    } 
    
    beforeDestroy() {
        Vue.filter('setSurveyProgress')(this.survey, this.currentStep, this.currentPage, 50, true);
        
        this.UpdateStepResultData({step:this.step, data: {aboutExistingChildSupportSurvey: Vue.filter('getSurveyResults')(this.survey, this.currentStep, this.currentPage)}})
    }
}
